import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Export from './Export';
import Binomes from './index';

const BinomesRoutes: FC = () => {
  return (
    <Routes>
      <Route path="" element={<Binomes />} />
      <Route path="/export" element={<Export />} />
    </Routes>
  );
};

export default BinomesRoutes;